import { ChangeDetectionStrategy, Component, OnInit, ViewChild, ElementRef, NgZone, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { BeschreibungService } from 'src/app/services/beschreibung.service';
import { BeschreibungOptions } from 'src/app/types/beschreibung-types';
import { ClarityModule, ClrModalModule } from '@clr/angular';
import { CommonModule } from '@angular/common';
import { take } from 'rxjs/operators';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-beschreibung-dialog',
  imports: [ClrModalModule, CommonModule, ClarityModule],
  templateUrl: './beschreibung-dialog.component.html',
  styleUrl: './beschreibung-dialog.component.scss',
})
export class BeschreibungDialogComponent implements OnInit {
  private confirmService = inject(BeschreibungService);
  private zone = inject(NgZone);

  open = false;
  options!: BeschreibungOptions;

  @ViewChild('okBtn') okButton!: ElementRef<HTMLButtonElement>;

  ngOnInit(): void {
    this.confirmService.confirmState$.subscribe(state => {
      this.options = state.options;
      this.open = true;

      this.zone.onStable
        .asObservable()
        .pipe(take(1))
        .subscribe(() => {
          this.okButton?.nativeElement.focus();
        });
    });
  }

  ok(): void {
    this.open = false;
  }
}
